module.exports = __webpack_public_path__ + "img/magento-vertical.eea62bea.svg";